import {InjectionToken} from '@angular/core';

export type DDMrpStockStatus = {
	name: string;
	class: string;
};

export interface Defaults {
	ddMrpStockStatuses: DDMrpStockStatus[];
}

export const DEFAULTS: Defaults = {
	ddMrpStockStatuses: [
		{name: 'No Stock', class: 'text-neutral-900'},
		{name: 'Low Safety Stock', class: 'text-red-600'},
		{name: 'Repl. not in progress', class: 'text-orange-500'},
		{name: 'Repl. in progress', class: 'text-yellow-300'},
		{name: 'OK', class: 'text-green-400'},
		{name: 'Excess', class: 'text-blue-400'},
	],
};

export const DEFAULTS_TOKEN = new InjectionToken<Defaults>('defaults');
